import React, { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { ButtonComp } from 'atoms/Buttons';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import NOT_FOUND_404_ERROR from '../../organisms/NotFound/Constants/NotFoundErrorConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { login, createAccount } from 'common/utilities/LoginUtils';
import { SESSION_STORAGE_KEYS, DELETE_KEY } from 'common/constants/SharedConstants';

export const SignOutDeleteAccountPage = ({ history, pageFlag }) => {
  const {
    TAKE_ME_HOME_TEXT,
    SIGN_UP_TEXT,
    SIGN_OUT_MESSAGE1,
    SIGN_OUT_MESSAGE2,
    SIGN_OUT_FAIL_MESSAGE1,
    SIGN_OUT_FAIL_MESSAGE2,
    DELETE_ACCOUNT_MESSAGE,
    SIGN_IN_TEXT,
  } = NOT_FOUND_404_ERROR;
  const { FORCED_SIGN_OUT } = SESSION_STORAGE_KEYS;
  const forcedSignout = sessionStorage.getItem(FORCED_SIGN_OUT) || false;
  const [showTakeHomeBtn, setShowTakeHomeBtn] = useState(false);
  const { ConfirmedSignOut } = IMAGE_PATH;
  const gotToHome = () => {
    history.push({
      pathname: '/',
    });
  };
  const [message, setMessage] = useState('');

  const redirectTo = e => {
    sessionStorage.removeItem(FORCED_SIGN_OUT);
    pageFlag === DELETE_KEY.toUpperCase() ? createAccount() : login();
  };

  const showSignoutMsgTxt = () => {
    let msg = '';
    if (pageFlag === 'DELETE') {
      msg = translateWithI18Next(DELETE_ACCOUNT_MESSAGE);
    } else if (forcedSignout) {
      msg = `${translateWithI18Next(SIGN_OUT_FAIL_MESSAGE1)}${'\n'}${translateWithI18Next(SIGN_OUT_FAIL_MESSAGE2)}`;
    } else {
      msg = `${translateWithI18Next(SIGN_OUT_MESSAGE1)}${'\n'}${translateWithI18Next(SIGN_OUT_MESSAGE2)}`;
    }

    return msg;
  };

  useEffect(() => {
    if (history?.location?.state === DELETE_KEY.toUpperCase()) {
      setShowTakeHomeBtn(true);
    } else {
      setShowTakeHomeBtn(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history?.location?.state]);

  useEffect(() => {
    return () => {
      sessionStorage.removeItem(FORCED_SIGN_OUT);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setMessage(showSignoutMsgTxt());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);

  const signInButtonClassName = () => {
    let newClassName = 'sign-up-account-remove';
    if (forcedSignout) {
      newClassName += ' sign-up-account-remove-login-fail';
    }
    return newClassName;
  };

  return (
    <React.Fragment>
      {/*RENDEV-8604 - removed if condition because it was not working for all Error messages instead using useEffect above*/}
      <div className='account-remove-container'>
        <div className='account-remove-confirm-icon'>
          <ReactSVG src={ConfirmedSignOut} />
        </div>
        <div className='main-text-account-remove'>{showSignoutMsgTxt()}</div>
        <div className='account-remove-buttons'>
          <ButtonComp data-testid='sign-upid' className={signInButtonClassName()} onClick={redirectTo}>
            {pageFlag === 'DELETE' ? translateWithI18Next(SIGN_UP_TEXT) : translateWithI18Next(SIGN_IN_TEXT)}
          </ButtonComp>
          {(!forcedSignout || showTakeHomeBtn) && (
            <ButtonComp data-testid='take-me-homeid' className='take-me-home-account-remove' onClick={gotToHome}>
              {translateWithI18Next(TAKE_ME_HOME_TEXT)}
            </ButtonComp>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};
